
import { DUMMY } from '../../config/constants';


const Etsydummypanel = ({ children }) => {

    function CornerSvg({ css }) {
        return (
            <svg
                viewBox="0 0 33 33"
                className="css-fxy4fc"
                style={css}
            >
                <g
                    className="corner-element"
                    stroke="currentColor"
                    strokeWidth="1px"
                    fill="none"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                    style={{ transition: '0.3s' }}
                >
                    <path d="M1 33V22.6C13.0861 22.6 22.8839 12.9293 22.8839 1H33" />

                    <path
                        d="M7.36328 2.14941C8.54299 4.36813 10.3586 6.18327 12.5771 7.36328C10.3587 8.5431 8.5431 10.3587 7.36328 12.5771C6.18327 10.3586 4.36813 8.54299 2.14941 7.36328C4.36823 6.18338 6.18338 4.36823 7.36328 2.14941Z"
                        fill="currentColor"
                    />
                </g>
            </svg>
        );
    }

    return DUMMY
        ? <div className='Drawbookedit_helptext' >
            <CornerSvg css={{ width: 30, height: 'auto', position: 'absolute', top: 10, left: 10 }} />
            <CornerSvg css={{ width: 30, height: 'auto', position: 'absolute', top: 10, right: 10, transform: 'rotate(90deg)' }} />
            <CornerSvg css={{ width: 30, height: 'auto', position: 'absolute', bottom: 10, right: 10, transform: 'rotate(180deg)' }} />
            <CornerSvg css={{ width: 30, height: 'auto', position: 'absolute', bottom: 10, left: 10, transform: 'rotate(-90deg)' }} />
            {children}
        </div>
        : null
}


export default Etsydummypanel